export const COMPONENT_INTERFACE = {
  STRING_INPUT: 'StringInput',
  MULTI_SELECT: 'MultiSelect',
  SINGLE_SELECT: 'SingleSelect',
  TOGGLE: 'Toggle',
  DATE_TIME: 'DateTime',
  NUMBER_PAD: 'NumberPad',
  CREW_INPUT: 'CrewInput',
  INFO: 'Info',
}
